import * as React from 'react';
import * as Modal from 'react-modal';
import {
  ModalBody,
  ModalFooter,
  ModalHeader,
} from '../../../../entities/modal';

const LastCommentState = {
  open: false,
};

interface Props {
  data: any;
}

interface State {
  open: boolean;
  lastComment?: string;
  status?: string;
  userRole?: string;
  loaders?: any;
}

// TODO: Сделать прокси исходя статуса для модалки STATUS[field]: Proxy->ComponentBody[status]
export class LastComment extends React.Component<Props, State> {
  state = { ...LastCommentState };

  componentDidMount(): void {
    this.formLoadActions(this.props);
  }

  // TODO: устарел метод
  // eslint-disable-next-line react/no-deprecated
  componentWillUpdate(nextProps: Readonly<Props>): void {
    const {
      data: { status, userRole },
    } = this.props;

    if (
      nextProps.data.status !== status ||
      nextProps.data.userRole !== userRole
    ) {
      this.formLoadActions(nextProps);
    }
  }

  formLoadActions = (props?: any): void => {
    const { data } = props;
    const {
      status,
      userRole,
      extRules: { ActionsRules },
    } = data;

    if (!data) {
      this.setState({ open: false });
    }
    if (!userRole) {
      return;
    }
    if (
      ActionsRules?.[userRole]?.[status] &&
      !!ActionsRules?.[userRole]?.[status].showOnLoad
    ) {
      this.show();
    } else {
      this.setState({ open: false });
    }
  };

  show = () => {
    this.setState({
      open: true,
    });
  };

  onClose = () => {
    this.setState({ ...LastCommentState });
  };

  onOK = () => {
    this.setState({ ...LastCommentState });
  };

  render() {
    const { open } = this.state;
    const {
      data: {
        history,
        status,
        userRole,
        loaders,
        extRules: { ActionsDefaultState, ActionsRules },
      },
    } = this.props;

    const isQuestion = status === 20;
    const text =
      history && history.length && history[0].comment
        ? history[0].comment
        : 'Комментарий не найден';
    const availableQuestion = history?.find(
      (_h) => _h?.status === 'Требуется уточнение',
    );
    const questionText = availableQuestion?.comment
      ? availableQuestion.comment
      : 'Уточнение не найдено';

    const title =
      ActionsRules && ActionsRules?.[userRole]?.[status]
        ? ActionsRules[userRole][status].lastComment
        : ActionsDefaultState.lastComment;
    const viewText = isQuestion ? questionText : text;

    return (
      // @ts-ignore
      <Modal
        isOpen={open}
        ariaHideApp={false}
        className="react-bs-insert-modal modal-dialog"
        contentLabel="Modal"
      >
        <div className="modal-content react-bs-table-insert-modal">
          <ModalHeader onClose={this.onClose}>
            {isQuestion ? 'Требуется уточнение' : title}
          </ModalHeader>
          <ModalBody>
            {!loaders?.['request-history'] ? (
              viewText
            ) : (
              // todo: отправить лоадер в shared или юзать существующий (Dots)
              <span
                className="loader justify-content-center"
                style={{
                  justifyContent: 'center',
                  display: 'flex',
                  width: '100%',
                }}
              >
                <span className="loader__item" />
                <span className="loader__item" />
                <span className="loader__item" />
              </span>
            )}
          </ModalBody>
          <ModalFooter onSubmit={this.onOK} onClose={this.onClose} />
        </div>
      </Modal>
    );
  }
}
